export const getIndustry = (data = [], filterDeprecated = false, valueKey = '', convertChild) => {
  const firstArr = [];
  const secondArr = [];
  const endArr = [];
  data.forEach((v) => {
    if (filterDeprecated && v.status === 'deprecated') return;
    if (v.level == 1) {
      firstArr.push({
        value: v[valueKey] || v.industry_id || v.industryId,
        desc: v.industry_name || v.display_name || v.displayName || v.name,
        options: [],
        id: v.industry_id || v.industryId,
      });
    }
    if (v.level == 2) {
      secondArr.push({
        value: v[valueKey] || v.industry_id || v.industryId,
        desc: v.industry_name || v.display_name || v.displayName || v.name,
        parent_id: v.parent_id || v.parentId,
        id: v.industry_id || v.industryId,
      });
    }
  });
  firstArr.forEach((v) => {
    secondArr.forEach((i) => {
      if (v.id == i.parent_id) {
        v.options.push(typeof convertChild === 'function' ? convertChild(i, v) : i);
      }
    });
    endArr.push(v);
  });
  return endArr;
};

/**
 * 根据行业id返回行业中文
 * @param {*} data 行业数组
 * @param {*} id 行业id
 * @returns
 */
export const getIndustryLabel = (data, id) => {
  if (!data || !data.length || !id) return '';
  const map = data.reduce((map, v) => {
    const { industry_id } = v;
    return { ...map, [industry_id]: v };
  }, {});
  const labelArr = [];
  let curId = id;
  while (map[curId]) {
    const { industry_name, parent_id } = map[curId];
    labelArr.unshift(industry_name);
    curId = parent_id;
  }

  // 不展示顶层行业
  labelArr.shift();

  return labelArr.join('-');
};

export const getIndustryInfo = (data, options = {}) => {
  const { valueKey = '', valueWithParent = false } = options;
  const mapping = {};
  const items = [];
  data.forEach((v) => {
    const { level, status } = v;
    const industryId = v.industry_id || v.industryId;
    const name = v.industry_name || v.display_name || v.displayName || v.name;
    const parentId = v.parent_id || v.parentId;
    if (!mapping[industryId]) {
      mapping[industryId] = {
        value: v[valueKey] || industryId,
        desc: name,
      };
      if (level === 2) {
        mapping[industryId].parent_id = parentId;
      }
    }
    if (status === undefined || status === 'active') {
      if (level === 1) {
        if (!mapping[industryId].options) {
          mapping[industryId].options = [];
        }
        items.push(mapping[industryId]);
      } else if (level === 2) {
        if (mapping[parentId]) {
          mapping[parentId].options.push(mapping[industryId]);
        } else {
          mapping[parentId].options = [mapping[industryId]];
        }
      }
    }
  });

  const withoutChilren = {};
  Object.keys(mapping).forEach((v) => {
    const { value, desc, parent_id: parentId } = mapping[v];
    withoutChilren[v] = { value, desc };
    if (parentId) {
      withoutChilren[v].parent_id = parentId;
      if (valueWithParent) {
        mapping[v].value = `${mapping[parentId].value}|${value}`;
      }
    }
  });

  return { map: withoutChilren, items };
};

export default {
  getIndustry,
  getIndustryLabel,
};
